import * as Schema from "effect/Schema";
import { IsoDateTime, TrimmedNonEmptyString } from "./baseSchemas.ts";

export const WorkFinding = Schema.Struct({
  text: TrimmedNonEmptyString,
  evidenceIds: Schema.Array(TrimmedNonEmptyString),
});
export type WorkFinding = typeof WorkFinding.Type;

export const WorkBrief = Schema.Struct({
  findings: Schema.Array(WorkFinding),
  openIssues: Schema.Array(TrimmedNonEmptyString),
  nextAction: TrimmedNonEmptyString,
  updatedAt: IsoDateTime,
});
export type WorkBrief = typeof WorkBrief.Type;

export const WorkVerification = Schema.Struct({
  id: TrimmedNonEmptyString,
  revision: TrimmedNonEmptyString,
  basis: Schema.optionalKey(TrimmedNonEmptyString),
  result: Schema.optionalKey(TrimmedNonEmptyString),
  passed: Schema.Boolean,
  current: Schema.optionalKey(Schema.Boolean),
  checkedAt: IsoDateTime,
  detail: Schema.NullOr(Schema.String),
  checks: Schema.Array(
    Schema.Struct({
      criterion: TrimmedNonEmptyString,
      passed: Schema.Boolean,
      evidenceIds: Schema.Array(TrimmedNonEmptyString),
      detail: TrimmedNonEmptyString,
    }),
  ),
  deterministic: Schema.optionalKey(
    Schema.Array(
      Schema.Struct({
        kind: TrimmedNonEmptyString,
        passed: Schema.Boolean,
        evidenceId: Schema.optionalKey(TrimmedNonEmptyString),
        path: Schema.optionalKey(Schema.String),
        expected: Schema.optionalKey(Schema.Unknown),
        observed: Schema.optionalKey(Schema.Unknown),
      }),
    ),
  ),
});
export type WorkVerification = typeof WorkVerification.Type;
